var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"under"},[_c('HuliNavigationVue',{attrs:{"current-page":_vm.currentPage}}),_c('HuliProjects'),_c('HuliFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }